import { Divider, Grid, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { FieldValues, Validate } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AddButton from "../../../common/components/functional/addButton/AddButton";
import { CustomerUser } from "../types/queries";
import UserEmailAddress from "./UserEmailAddress";

type Props = {
  customerUsers?: CustomerUser[];
  handleUserPrefill?: (customerUser: CustomerUser | null) => void;
  userId?: string;
  clearEmailError: () => void;
  validateEmailAddress: Validate<string, FieldValues>;
  prefilledUser: CustomerUser | null;
  setCreateNewUser: Dispatch<SetStateAction<boolean>>;
  isCustomerUser?: boolean;
  error: boolean;
};

const CustomerUserPrefill = ({
  handleUserPrefill,
  customerUsers,
  userId,
  clearEmailError,
  validateEmailAddress,
  prefilledUser,
  isCustomerUser,
  setCreateNewUser,
  error,
}: Props) => {
  const { t } = useTranslation();

  const disableCreateNewButton = !!prefilledUser || error;

  const buttonLabel = isCustomerUser
    ? t("customers:usersNS:createCustomerUser")
    : t("customers:usersNS:createCustomerContact");

  return (
    <>
      <Grid item xs={3} alignSelf="flex-start">
        <Typography
          sx={{ marginTop: "8px" }}
          color="textSecondary"
          align="right"
        >
          {t("common:email")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <UserEmailAddress
          handleUserPrefill={handleUserPrefill}
          customerUsers={customerUsers}
          userId={userId}
          clearEmailError={clearEmailError}
          validateEmailAddress={validateEmailAddress}
          prefilledUser={prefilledUser}
          isCustomerUser={isCustomerUser}
        />
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ width: "100%", margin: "1rem 0" }} />
      </Grid>
      <Grid container item xs={12} justifyContent="center">
        <AddButton
          label={buttonLabel}
          sx={{ borderRadius: "18px", minHeight: "36px" }}
          variant="outlined"
          disabled={disableCreateNewButton}
          onClick={() => setCreateNewUser(true)}
        />
      </Grid>
    </>
  );
};

export default CustomerUserPrefill;
